import { Breadcrumb, Flex, Space, Typography } from 'antd';
import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { brandRamp } from '../theme';

export interface Crumb {
  title: string;
  to?: string;
}

interface Props {
  title: ReactNode;
  subtitle?: ReactNode;
  crumbs?: Crumb[];
  tags?: ReactNode;
  actions?: ReactNode;
  extra?: ReactNode;
  icon?: ReactNode;
}

/**
 * Title block shared by every page, as on Microsoft's sites: breadcrumb, the title in Fluent's
 * Title 3 (24/32 semibold) with tags, one line of purpose in secondary text, actions at the end.
 */
export function PageHeader({ title, subtitle, crumbs, tags, actions, extra, icon }: Props) {
  return (
    <div style={{ marginBottom: 24 }}>
      {crumbs && crumbs.length > 0 && (
        <Breadcrumb
          style={{ marginBottom: 8 }}
          items={crumbs.map((c) => ({ title: c.to ? <Link to={c.to}>{c.title}</Link> : c.title }))}
        />
      )}
      <Flex justify="space-between" align="flex-start" gap={16} wrap>
        <Flex gap={14} align="flex-start" style={{ minWidth: 0 }}>
          {icon && (
            <div
              style={{
                width: 40,
                height: 40,
                borderRadius: 8,
                background: brandRamp[150],
                color: brandRamp[80],
                display: 'grid',
                placeItems: 'center',
                fontSize: 20,
                flex: 'none',
              }}
            >
              {icon}
            </div>
          )}
          <div style={{ minWidth: 0 }}>
            <Flex align="center" gap={10} wrap>
              <Typography.Title level={4} style={{ margin: 0, fontWeight: 600 }}>
                {title}
              </Typography.Title>
              {tags}
            </Flex>
            {subtitle && (
              <Typography.Text
                type="secondary"
                style={{ display: 'block', marginTop: 2, maxWidth: 820 }}
              >
                {subtitle}
              </Typography.Text>
            )}
          </div>
        </Flex>
        {actions && (
          <Space wrap data-tour="page-actions">
            {actions}
          </Space>
        )}
      </Flex>
      {extra && <div style={{ marginTop: 16 }}>{extra}</div>}
    </div>
  );
}
